export interface InitAppState {}

export const initAppState: InitAppState = {};
